export function buildMapsUrls(address) {
  if (!address || !String(address).trim()) return null;
  const encoded = encodeURIComponent(String(address).trim());
  return {
    google: `https://www.google.com/maps/search/?api=1&query=${encoded}`,
    waze: `https://waze.com/ul?q=${encoded}&navigate=yes`,
  };
}
